// Debounces a fast-changing value (e.g. a search input) so dependents (a
// TanStack Query key, a URLSearchParams sync) only react once the value has
// been stable for `delayMs` — used for server-side search inputs where every
// keystroke would otherwise re-trigger a network fetch.

import { useEffect, useState } from 'react';

export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return debounced;
}
